"use client";

import React, { useEffect, useRef, useState } from "react";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
export default function AboutCopy2() {
  const {
    ref: headlineRef,
    isVisible: isHeadlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  return <section data-section-id="225387" id="transition" className="relative w-full overflow-hidden bg-background py-48 md:py-72 lg:py-96 bg-cover bg-no-repeat bg-center !bg-[url(https://lesbrisesanticosti.com/wp-content/uploads/2026/06/chambre-de-bain.avif)]">      {}
      <div className="absolute inset-0 z-5 bg-gradient-to-b from-background via-transparent to-background"></div>
      <div className="absolute inset-0 z-5 bg-gradient-to-r from-background via-transparent to-background opacity-50"></div>
      <div className="pointer-events-none absolute inset-0 z-0 flex justify-evenly opacity-30">
        <div className="h-full w-px bg-border/20" />
        <div className="h-full w-px bg-border/20" />
        <div className="h-full w-px bg-border/20" />
        <div className="hidden h-full w-px bg-border/20 md:block" />
      </div>

      <div className="container relative z-10 mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 items-start gap-16 lg:grid-cols-12 lg:gap-24">
          {}
          <div className="lg:col-span-7">
            <h2 ref={headlineRef} className="font-default text-5xl font-bold uppercase leading-[1.1] tracking-tighter text-foreground md:text-7xl lg:text-8xl">
              <span className="block overflow-hidden pb-2">
                
              </span>
              <span className="block overflow-hidden pb-2">
                
              </span>
              <span className="block overflow-hidden pb-2">
                <span className={`block tracking-normal transition-transform duration-1000 delay-300 cubic-bezier(0.22, 1, 0.36, 1) ${isHeadlineVisible ? "translate-y-0" : "translate-y-full"}`}>PRATIQUE.</span>
              </span>
            </h2>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col justify-center pt-4 transition-all duration-1000 delay-500 lg:col-span-5 lg:pt-12 ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="mb-8 h-px w-12 bg-border" />
            
          </div>
        </div>
      </div>
    </section>;
}